export const getBundle = state => (packageName, name) => {
  const [bundle] = state.content.filter(item => item.package === packageName && item.name === name);

  return bundle;
};

export const getContent = state => state.content;

export default {
  getBundle,
  getContent
};



// WEBPACK FOOTER //
// ./src/store/modules/bundles/getters.js